// Global button rules (src/index.css, App.css) add a lift, shadow and brand
// colors to every button; these neutralise them, as on the Book It page.
const RESET =
  "!shadow-none !border-0 hover:!translate-y-0 active:!translate-y-0 !tracking-normal";

const BLOCK = `${RESET} w-full !rounded-full active:!scale-[0.98] disabled:!opacity-40 !px-[16px] !py-[12px] !font-[Roboto] !text-[16px] !font-semibold !transition-[background-color,opacity,transform] !duration-200`;

export const solidButton = `${BLOCK} !bg-indigo-600 hover:!bg-indigo-700 !text-white`;

export const linkButton = `${RESET} !bg-transparent hover:!bg-transparent !p-0 !font-[Roboto] !text-[13px] !font-medium !text-slate-500 hover:!text-slate-700 underline underline-offset-2 disabled:!opacity-40`;
